export default __webpack_public_path__ + "static/media/slide-img.007a3fd2.jpg";